import { DripHistoryItem } from "../../hooks/useDripHistory";

const latestRewardTimeByMint = (history: DripHistoryItem[]): Record<string, number> => {
  const latest: Record<string, number> = {};

  for (const item of history) {
    const timestamp = new Date(item.timestamp).getTime();
    if (!Number.isFinite(timestamp)) continue;
    latest[item.mint] = Math.max(latest[item.mint] ?? 0, timestamp);
  }

  return latest;
};

/**
 * Most recently rewarded asset first, with one exception: `pinnedMint` leads
 * whenever the wallet holds it. A partner page is about one token, so that
 * token owns the first tab (and so the default selection) even on a wallet
 * whose other rewards landed more recently.
 */
export const sortAssetMintsByLatestReward = (
  mints: string[],
  history: DripHistoryItem[],
  pinnedMint?: string
): string[] => {
  const latestByMint = latestRewardTimeByMint(history);

  return [...mints].sort((a, b) => {
    if (a === pinnedMint) return -1;
    if (b === pinnedMint) return 1;

    const timeA = latestByMint[a] ?? 0;
    const timeB = latestByMint[b] ?? 0;
    return timeB - timeA;
  });
};
